import { Button, TextField, Typography } from "@material-ui/core"
import { Form, Formik } from "formik"
import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { useMutation } from "react-query"
import { useHistory } from "react-router-dom"
import * as Yup from "yup"
import { otpRequest, otpVerify } from "~/actions/users"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import App from "~/contexts/App"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const OTPForm = ({ setLoginStep, adminId, adminPhone }) => {
  const authContext = useContext(App)

  const history = useHistory()
  const openErrorSnackbar = useOpenErrorSnackbar()

  const classes = useStyles()
  const [phoneNumber, setPhoneNumber] = useState("")
  const [codeShow, setCodeShow] = useState(false)
  const [resendCode, setResendCode] = useState(false)

  const { openSnackBar } = useContext(App)

  const otpSchema = Yup.object().shape({
    phone: Yup.string().required().length(10),
  })

  //come back to loginForm compoment
  const backToLogin = () => {
    setLoginStep(0)
  }

  const otpRequestMutation = useMutation(otpRequest)
  const otpVerifyMutation = useMutation(otpVerify)

  useEffect(() => {
    if (authContext && authContext.token) {
      history.push("/courses")
    }
  }, [authContext])

  useEffect(() => {
    if (adminPhone !== null) {
      setCodeShow(true)
      otpRequestMutation.mutate(
        { phone: adminPhone },
        {
          onSuccess: (res) => {
            openSnackBar({
              message: "A verification code was sent to your phone",
            })
          },
          onError: (err) => {
            openErrorSnackbar(
              "There was an error sending your code. Please Try Again",
              err,
            )
          },
        },
      )
    }
  }, [resendCode])

  const onSubmit = (values, actions) => {
    if (codeShow === true) {
      otpVerifyMutation.mutate(
        { values, adminId: adminId, adminPhone: adminPhone },
        {
          onSuccess: (res) => {
            if (res.invalidCode === true) {
              openSnackBar({
                message: "Code invalid - Please check and try again",
              })
              return
            } else {
              authContext.setAuthToken(res.token)
              setLoginStep(3)
            }
          },
          onError: (err) => {
            openErrorSnackbar(
              "There was an error verifying your code. Please try again",
              err,
            )
          },
          onSettled: () => actions.setSubmitting(false),
        },
      )
    } else {
      otpRequestMutation.mutate(values, {
        onSuccess: (res) => {
          setCodeShow(true)
          openSnackBar({
            message: "A verification code was sent to your phone",
          })
        },
        onError: (err) => {
          console.error(err)
          openErrorSnackbar(
            "There was an error sending your code. Please try again",
            err,
          )
        },
        onSettled: () => actions.setSubmitting(false),
      })
    }
  }

  const onPhoneNumberChange = (value) => {
    var x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    let y = (value = !x[2]
      ? x[1]
      : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : ""))
    setPhoneNumber(y)
  }

  return (
    <Formik
      initialValues={{ phone: adminPhone || "" }}
      onSubmit={onSubmit}
      validationSchema={otpSchema}
    >
      {({
        handleChange,
        setFieldValue,
        values,
        errors,
        touched,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <div className={classes.inputContainer}>
          <Form>
            {!codeShow && adminPhone === null && (
              <>
                <Typography className={classes.explanation} variant="subtitle2">
                  Please enter your Mobile Number to be associated with your
                  account (SMS required)
                </Typography>
                <Typography color="secondary" className={classes.title}>
                  Phone Number
                </Typography>
                <TextField
                  type="phone"
                  name="phone"
                  id="phone"
                  value={phoneNumber}
                  placeholder="(555) 555-5555"
                  onChange={(e) => {
                    const value = e.target.value
                    setFieldValue("phone", value.replace(/[^\d]/g, ""))
                    onPhoneNumberChange(value)
                  }}
                  onBlur={handleBlur}
                  className={classes.textField}
                  helperText={
                    <span>
                      {touched.phone && errors.phone ? errors.phone : " "}
                    </span>
                  }
                  InputProps={{
                    classes: {
                      root: classes.inputBackgroundColor,
                    },
                  }}
                  error={!!touched.phone && !!errors.phone}
                  variant="outlined"
                  size="small"
                  fullWidth
                  FormHelperTextProps={{
                    className: classes.formHelperText,
                  }}
                />
              </>
            )}
            {codeShow && (
              <div>
                <Typography className={classes.explanation} variant="subtitle2">
                  Please enter the One-Time Code sent to your mobile device
                </Typography>
                <Box className={classes.oneTime}>
                  <Typography
                    color="secondary"
                    style={{
                      fontSize: "0.8125rem",
                      fontWeight: "bold",
                    }}
                  >
                    One Time Code
                  </Typography>
                  <Button
                    color="secondary"
                    style={{ height: "40px" }}
                    disabled={resendCode}
                    onClick={() => setResendCode(true)}
                  >
                    Resend Code
                  </Button>
                </Box>

                <TextField
                  type="text"
                  name="otpcode"
                  id="otpcode"
                  value={values.otpCode}
                  // placeholder="Email"
                  // label="Email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={classes.textField}
                  helperText={
                    <span>
                      {touched.otpCode && errors.otpCode ? errors.otpCode : " "}
                    </span>
                  }
                  InputProps={{
                    classes: {
                      root: classes.inputBackgroundColor,
                    },
                  }}
                  error={!!touched.otpCode && !!errors.otpCode}
                  variant="outlined"
                  size="small"
                  fullWidth
                  FormHelperTextProps={{
                    className: classes.formHelperText,
                  }}
                />
              </div>
            )}

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              marginTop="30px"
            >
              <Button
                variant="outlined"
                color="secondary"
                style={{ height: "40px" }}
                onClick={backToLogin}
              >
                Cancel
              </Button>
              <LoaderButton
                type="submit"
                classoverrides={{
                  wrapper: classes.button,
                  button: {
                    root: classes.buttonRoot,
                  },
                }}
                variant="contained"
                color="secondary"
                working={isSubmitting}
                size="small"
              >
                {codeShow ? "Submit" : "Send Code"}
              </LoaderButton>
            </Box>
          </Form>
        </div>
      )}
    </Formik>
  )
}

OTPForm.propTypes = {
  setLoginStep: PropTypes.func,
  adminId: PropTypes.number,
  adminPhone: PropTypes.string,
}

export default OTPForm
